import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { coordinateSystemsKey } from './coordinate-systems.state';
import { coordinateSystemsReducer } from './coordinate-systems.reducer';
import * as coordinateSystemsEffects from './coordinate-systems.effects';

export function provideCoordinateSystemsStore(): EnvironmentProviders[] {
  return [
    provideState({ name: coordinateSystemsKey, reducer: coordinateSystemsReducer }),
    provideEffects(coordinateSystemsEffects),
  ];
}
